import { DemoTender } from "components/page-components/Native-Inhouse-Ads"
import React from "react"
import { ArticleContentComponentContainer } from "../utils"

export const ArticleDemoTender = ({ demo_tender_data }) => {
  return (
    <ArticleContentComponentContainer
      {...{
        custom_classes: "py-3",
        attributes: { "data-nosnippet": true },
      }}
    >
      <DemoTender {...{ demo_tender_data }} />
    </ArticleContentComponentContainer>
  )
}
